export function SectionDivider({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-center gap-3 my-2">
      <div className="flex-1 h-px bg-postal-divider" />
      <span>{children}</span>
      <div className="flex-1 h-px bg-postal-divider" />
    </div>
  )
}
